import { Controller } from "@hotwired/stimulus";

/*
Usage:
<div
  class="c-homeProjects"
  data-controller="home-projects"
  data-home-projects-offset-value="130"
  data-home-projects-scale-to-value="0.96"
  data-home-projects-translate-to-value="-12"
>
  <div class="c-homeProjects-slide" data-home-projects-target="slide">...</div>
  ...
</div>
*/

export default class extends Controller {
    static targets = ["slide"];
    static values = {
        offset: { type: Number, default: 130 },       // top sticky
        scaleTo: { type: Number, default: 0.94 },     // scale min du slide compressé
        translateTo: { type: Number, default: -50 },  // translateY min (px)
    };

    connect() {
        this._raf = null;
        this._onScroll = () => this.requestUpdate();
        this._onResize = () => this.requestUpdate();

        window.addEventListener("scroll", this._onScroll, { passive: true });
        window.addEventListener("resize", this._onResize, { passive: true });

        this.requestUpdate();
    }

    disconnect() {
        window.removeEventListener("scroll", this._onScroll);
        window.removeEventListener("resize", this._onResize);
        if (this._raf) cancelAnimationFrame(this._raf);
    }

    requestUpdate() {
        if (this._raf) return;
        this._raf = requestAnimationFrame(() => {
            this._raf = null;
            this.update();
        });
    }

    update() {
        const slides = this.slideTargets.filter(el => !el.classList.contains("js-is-spacer"));
        if (slides.length < 2) return;

        // reset
        const opacities = new Array(slides.length).fill(1);
        slides.forEach((s) => {
            s.style.transform = "translateY(0px) scale(1)";
            s.style.opacity = "1";
            s.style.willChange = "transform, opacity";
            s.style.transformOrigin = "50% 0%";
        });

        // Pour chaque slide i, on calcule la progression d’arrivée du slide i+1
        for (let i = 0; i < slides.length - 1; i++) {
            const current = slides[i];
            const next = slides[i + 1];

            const h = current.getBoundingClientRect().height || 1;
            const nextRect = next.getBoundingClientRect();

            // nextRect.top va de (offset + h) -> offset avant de coller (sticky)
            const p = this.clamp(1 - (nextRect.top - this.offsetValue) / h, 0, 1);

            // Compression + léger déplacement vers le haut sur le slide courant
            const scale = 1 - p * (1 - this.scaleToValue);
            const ty = p * this.translateToValue;

            current.style.transform = `translateY(${ty}px) scale(${scale})`;

            // Quand le suivant commence à recouvrir le courant,
            // on fade progressivement le slide précédent (i-1)
            if (i > 0) {
                opacities[i - 1] = Math.min(opacities[i - 1], 1 - p);
            }
        }

        // applique opacités calculées
        slides.forEach((s, i) => {
            s.style.opacity = String(opacities[i]);
        });
    }

    clamp(v, min, max) {
        return Math.max(min, Math.min(max, v));
    }
}
